export const CSS_CLASSES = {
  PAGINATION_ROOT: "pagination-root",
  PAGINATION_OPTIONS: "pagination-options",
  PAGINATION_OPTIONS_TEXT: "pagination-options-text",
  PAGINATION_OPTIONS_TEXT_MARKED: "pagination-options-text-marked",
  PAGINATION_OPTIONS_SELECT: "pagination-options-select",

  PAGINATION_ROOT_MOBILE: "pagination-root-mobile",
  PAGINATION_MOBILE_INFO: "pagination-mobile-info",
  PAGINATION_ALL_ITEMS_LINK: "pagination-all-items-link",

  PAGINATION_PAGE_BUTTONS_ROOT: "pagination-page-buttons-root",
  PAGINATION_ARROW_BUTTON: "pagination-arrow-button",
  PAGINATION_ARROW_BUTTON_HIDDEN: "pagination-arrow-button-hidden",
  PAGINATION_PAGE_BUTTONS: "pagination-page-buttons",
  PAGINATION_PAGE_BUTTON: "pagination-page-button",
  PAGINATION_ELLIPSIS: "pagination-ellipsis",
};
